module.exports = __webpack_public_path__ + "img/CrimsonText-Bold.ae70658d.svg";